function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { ModalHeader } from "./Header/ModalHeader";
import { ModalFooter } from "./Footer/ModalFooter";
import { ModalBody } from "./Body/ModalBody";
import { ModalTopHeaderText } from "./TopHeaderText/ModalTopHeaderText";
import { ModalTitle } from "./Title/ModalTitle";
import { ModalSubTitle } from "./Title/ModalSubTitle";
import { ModalSymbol } from "./Symbol/ModalSymbol";
import { ModalButton } from "./Button/ModalButton";
export var ESCAPE_KEY_CODE = 27;
export var MODAL_ELEMENTS = {
  HEADER: ModalHeader.name,
  FOOTER: ModalFooter.name,
  BODY: ModalBody.name,
  SYMBOL: ModalSymbol.name,
  STEPPER: ModalTopHeaderText.name,
  TITLE: ModalTitle.name,
  SUB_TITLE: ModalSubTitle.name,
  BUTTON: ModalButton.name
};
export var MODAL_FOOTER_MAX_OCCURENCES_OF_BUTTONS = 2;
export var MODAL_LAYOUT_ELEMENTS = _defineProperty(_defineProperty(_defineProperty({}, MODAL_ELEMENTS.HEADER, {
  isRequired: true,
  maxOccurences: 1
}), MODAL_ELEMENTS.FOOTER, {
  isRequired: false,
  maxOccurences: 1
}), MODAL_ELEMENTS.BODY, {
  isRequired: true,
  maxOccurences: 1
});
export var MODAL_HEADER_ELEMENTS = _defineProperty(_defineProperty(_defineProperty(_defineProperty({}, MODAL_ELEMENTS.SYMBOL, {
  isRequired: false,
  maxOccurences: 1
}), MODAL_ELEMENTS.STEPPER, {
  isRequired: false,
  maxOccurences: 1
}), MODAL_ELEMENTS.TITLE, {
  isRequired: true,
  maxOccurences: 1
}), MODAL_ELEMENTS.SUB_TITLE, {
  isRequired: false,
  maxOccurences: 1
});
export var MODAL_FOOTER_ELEMENTS = _defineProperty({}, MODAL_ELEMENTS.BUTTON, {
  isRequired: true,
  maxOccurences: MODAL_FOOTER_MAX_OCCURENCES_OF_BUTTONS
});